import { FC, useMemo } from 'react';

import { Box } from '@mui/material';

import { RiskLevelColors } from 'src/components/RiskLevels/RiskLevels';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';

import { RiskCard, RiskCardProps } from './components/RiskCard';
interface RisksSectionProps {
    isAddService?: boolean;
}

export const RisksSection: FC<RisksSectionProps> = ({ isAddService }) => {
    const { merchantApplication } = useAddMerchantContext();

    const RISKS: RiskCardProps[] = useMemo(() => {
        return [
            {
                label: 'Merchant Risk Level',
                value: merchantApplication?.serviceRequirements?.salesConditions
                    ?.merchantCategoryCode?.risk,
                valueStyle: {
                    color: RiskLevelColors[
                        merchantApplication?.serviceRequirements?.salesConditions
                            ?.merchantCategoryCode?.risk ?? 'NONE'
                    ],
                },
            },
            {
                label: 'Service Type',
                value: merchantApplication?.serviceRequirements?.service?.serviceType,
            },
            {
                label: 'Number of Outlets',
                value: merchantApplication?.merchantInformation?.numberOfOutlets,
            },
        ];
    }, [merchantApplication]);
    return (
        <Box display="flex" alignItems="center" gap="24px">
            {RISKS.map((risk) => {
                if (isAddService && risk.label === 'Service Type') {
                    return <RiskCard key={risk.label} {...risk} />;
                } else if (!isAddService) {
                    return <RiskCard key={risk.label} {...risk} />;
                }
            })}
        </Box>
    );
};
